export enum MenuAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_MENU_LIST = "ADD_MENU_LIST",
    UPDATE_MENU_LIST = "UPDATE_MENU_LIST",
    UPDATE_MENU_SEARCH_REQ = "UPDATE_MENU_SEARCH_REQ",
    SET_UPDATE_MENU = "SET_UPDATE_MENU",
}